/**
 * Shared types for the Create-ASN wizard (CR-4888 Slice C).
 */

export interface DeliveryLineOption {
  id: number;
  delivery_number: string;
  call_off: number | null;
  call_off_reference: string;
  part_number: string;
  part_description: string;
  qty_released: string;
  delivery_option: string;
  po_order_number: string;
  po_line_number: number | null;
  date_released: string;
}

export type SourceType = 'schedules' | 'delivery_lines';

export interface ASNFormData {
  schedules: number[];
  delivery_line_ids: number[];
  courier: string;
  courier_other: string;
  tracking_number: string;
  invoice_number: string;
  method_of_transport: string;
  weight_kg: string;
  expected_delivery_date: string;
  notes: string;
}

export const INITIAL_FORM_DATA: ASNFormData = {
  schedules: [],
  delivery_line_ids: [],
  courier: 'fedex',
  courier_other: '',
  tracking_number: '',
  invoice_number: '',
  method_of_transport: 'road',
  weight_kg: '',
  expected_delivery_date: '',
  notes: '',
};

export const WIZARD_STEPS = [
  'Source & Lines',
  'Shipment Details',
  'Review & Submit',
] as const;

export type StepIndex = 1 | 2 | 3;
